import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

import MyContext from "../../MyContext";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FaqSection from "./FaqSection";

import group9 from "../../images/LandingPageImage/about_us.webp";
import CtaSection from "./CtaSection";
// import FreeTrial from "./FreeTrial";

const slideData = {
  subtitle:
    "At Anlook, we help businesses turn everyday WhatsApp messages into meaningful customer interactions.",
  image: group9,
};

const AboutUs = ({ onLoginClick }) => {
  const { baseUrl, config } = useContext(MyContext);
  // const [showFreeTrial, setShowFreeTrial] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const [isVisible, setIsVisible] = useState(false);
  const [plans, setPlans] = useState([]);
  const [sessionID, setSessionId] = useState("");
  const [campaignIdHook, setCampaignIdHook] = useState("");
  const login = () => {
    const productId = "1";
    const callbackUrl = `${window.location.origin}/get`;
    const redirectUrl = `https://accounts.bumppy.com/?callback=${callbackUrl}&product_id=${productId}`;
    window.location.href = redirectUrl;
  };
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const generateUUID = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };

  useEffect(() => {
    const storedSessionID = sessionStorage.getItem("sessionID");
    if (storedSessionID) {
      setSessionId(storedSessionID);
    } else {
      const newSessionID = generateUUID();
      sessionStorage.setItem("sessionID", newSessionID);
      setSessionId(newSessionID);
    }
  }, []);

  useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    let campaignid = params.get("campaignid");

    if (!campaignid) {
      params = new URLSearchParams(window.location.hash.substring(1));
      campaignid = params.get("campaignid");
    }

    if (campaignid) {
      sessionStorage.setItem("campaignId", campaignid);
      setCampaignIdHook(campaignid);
    }
  }, []);

  const fetchSubscriptionPlans = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionPlans`,
        { userid: "", countryCode: "IN" },
        config
      );
      setPlans(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  useEffect(() => {
    if (sessionID) {
      fetchSubscriptionPlans();
    }
  }, [sessionID]);

  const trackClick = async (requestBody) => {
    try {
      await axios.post(`${baseUrl}/api/Blog/trackClickHeatMaps`, requestBody);
    } catch (error) {
      console.error("SEO Track Error:", error);
    }
  };

  const handleButtonClick_SEO = async (buttonName) => {
    const urlParams = new URLSearchParams(window.location.search);
    const storedTrackingData =
      JSON.parse(sessionStorage.getItem("trackingData")) || {};

    const requestBody = {
      campaignid: campaignIdHook,
      sessionid: sessionID,
      element: "Button",
      button_name: buttonName,
      pageurl: window.location.href,
      pagename: "About Page",
      product: "Anlook",
      utm_source: urlParams.get("utm_source") || storedTrackingData.utm_source,
    };

    await trackClick(requestBody);
  };

  const handleGetStarted = async () => {
    await handleButtonClick_SEO("Get Started");

    navigate("/get/GetStarted", {
      state: {
        plan: plans,
      },
    });
  };

  const handlePricing = async () => {
    await handleButtonClick_SEO("See Pricing");
    navigate("/pricing-page");
  };

  useEffect(() => {
    const pageKey = location.pathname;
    const storageKey = `freeTrialClosed_${pageKey}`;
    return () => sessionStorage.removeItem(storageKey);
  }, [location.pathname]);

  const slide = slideData;

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowFreeTrial(true);
  //   }, 10000); 

  //   return () => clearTimeout(timer);
  // }, [location.key]); 
  useEffect(() => {
    const currentUrl = window.location.href;
    const encodedUrl = encodeURIComponent(currentUrl);
    const script = document.createElement("script");
    script.src = `https://anlook.com/SeoBix/seo_injection.php?webid=56c53e1ff4273fa3746b406c70f5bf9c&url=${encodedUrl}&baseUrl=https%3A%2F%2Fanlook.com`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar onLoginClick={onLoginClick} />

      <section className="ls-hero" aria-label="About hero section">
        <div className="ls-hero__container">
          {/* LEFT */}
          <div className="ls-hero__left">
            <h1 className={`ls-hero__title ${isVisible ? "visible" : ""}`}>
              <span className="ls-text--accent">Smarter Business</span>
              <br />
              Conversations on WhatsApp
            </h1>

            <p className={`ls-hero__subtitle ${isVisible ? "visible" : ""}`}>
              {slide.subtitle}
            </p>

            <div className={`ls-hero__actions ${isVisible ? "visible" : ""}`}>
              <button
                className="ls-btn ls-btn--primary d-flex align-items-center gap-2"
                onClick={handleGetStarted}
              >
                Get Started
              </button>

              <button
                className="ls-btn ls-btn--primary d-flex align-items-center gap-2"
                onClick={handlePricing}
              >
                See Pricing
              </button>
            </div>
          </div>

          {/* RIGHT */}
          <div className="ls-hero__right" aria-hidden="true">
            <img
              src={slide.image}
              alt="WhatsApp automation illustration"
              className={`ls-hero__image ${isVisible ? "visible" : ""}`}
              loading="lazy"
              draggable={false}
            />
            {/* <div className="ls-hero__overlay" /> */}
          </div>
        </div>
      </section>

      <style>{`
:root {
  --hero-bg-1: #0C4D45;
  --hero-bg-2: #01C37D;
  --accent: #02C37D;
  --accent-light: #54BD95;
  --max-width: 1600px;

  --nav-padding-desktop: 5rem;
  --nav-padding-xl: 4rem;
  --nav-padding-lg: 3rem;
  --nav-padding-md: 2rem;
  --nav-padding-sm: 1.25rem;
}

/* SECTION */
.ls-hero {
  width: 100%;
  background: linear-gradient(135deg, var(--hero-bg-1), var(--hero-bg-2));
  padding: 4rem 0 0;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

/* CONTAINER */
.ls-hero__container {
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  padding-left: var(--nav-padding-desktop);
  padding-right: var(--nav-padding-desktop);
}

/* LEFT */
.ls-hero__left {
  flex: 1 1 48%;
  max-width: 720px;
  z-index: 3;
}

/* TITLE */
.ls-hero__title {
  font-size: 2.6rem;
  font-weight: 700;
  line-height: 1.12;
  color: #fff;
  margin: 0;
  opacity: 0;
  transform: translateX(-110%);
  transition: opacity 900ms cubic-bezier(.2,.9,.2,1),
              transform 900ms cubic-bezier(.2,.9,.2,1);
}

.ls-hero__title.visible {
  opacity: 1;
  transform: translateX(0);
}

.ls-text--accent {
  color: var(--accent);
}

/* SUBTITLE */
.ls-hero__subtitle {
  margin-top: 1rem;
  font-size: 1.05rem;
  color: #fff;
  line-height: 1.5;
  max-width: 45ch;
  opacity: 0;
  transform: translateX(-110%);
  transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 150ms,
              transform 900ms cubic-bezier(.2,.9,.2,1) 150ms;
}

.ls-hero__subtitle.visible {
  opacity: 1;
  transform: translateX(0);
}

/* ACTIONS */
.ls-hero__actions {
  margin-top: 1.5rem;
  display: flex;
  gap: 0.9rem;
  flex-wrap: wrap;
  opacity: 0;
  transform: translateX(-110%);
  transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 250ms,
              transform 900ms cubic-bezier(.2,.9,.2,1) 250ms;
}

.ls-hero__actions.visible {
  opacity: 1;
  transform: translateX(0);
}

/* BUTTONS */
.ls-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 0.6rem 1.2rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: background 200ms ease, color 200ms ease, transform 150ms ease;
}

.ls-btn--primary,
.ls-btn--secondary {
  background: var(--accent);
  color: #fff;
}

/* RIGHT */
.ls-hero__right {
  flex: 1 1 48%;
  max-width: 720px;
  height: 460px;
  max-height: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-right: calc(var(--nav-padding-desktop) * 0.6);
}

/* IMAGE */
.ls-hero__image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0;
  transform: translateX(80%);
  transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 120ms,
              transform 900ms cubic-bezier(.2,.9,.2,1) 120ms;
  pointer-events: none;
}

.ls-hero__image.visible {
  opacity: 1;
  transform: translateX(0);
}

/* OVERLAY */
.ls-hero__overlay {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(800px 400px at 10% 30%, rgba(255,255,255,0.03), transparent 10%),
    radial-gradient(600px 300px at 90% 70%, rgba(0,0,0,0.18), transparent 15%);
  pointer-events: none;
  z-index: 2;
}

/* RESPONSIVE */
@media (max-width: 1400px) {
  .ls-hero__container {
    padding-left: var(--nav-padding-xl);
    padding-right: var(--nav-padding-xl);
  }
}

@media (max-width: 1200px) {
  .ls-hero__container {
    padding-left: var(--nav-padding-lg);
    padding-right: var(--nav-padding-lg);
  }
}

@media (max-width: 992px) {
  .ls-hero__container {
    flex-direction: column;
    text-align: center;
    padding-left: var(--nav-padding-md);
    padding-right: var(--nav-padding-md);
  }

  .ls-hero__subtitle {
    margin-left: auto;
    margin-right: auto;
  }

  .ls-hero__actions {
    justify-content: center;
  }

  .ls-hero__right {
    height: 360px;
    padding-right: 0;
  }
}

@media (max-width: 768px) {
  .ls-hero__container {
    padding-left: var(--nav-padding-sm);
    padding-right: var(--nav-padding-sm);
  }

  .ls-hero__title { font-size: 1.6rem; }
}

@media (max-width: 480px) {
  .ls-hero__right { height: 240px; }
}
        `}</style>

      {/* second section  */}
      <>
        <style>{`
        .content-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 60px 20px;
        }

       .content-title {
            font-size: 32px;
            font-weight: 700;
            margin: 0 auto 24px;   
            display: flex;
            align-items: center;
            justify-content: center;
            max-width: 600px;
            text-align: center;
            color: #0C4D45;
            }

            .content-para {
            max-width: 900px;
            margin: 0 auto 15px;
            line-height: 1.5;
            color: #444;
            font-size: 16px;
            text-align: center;
            }

        .card-row {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
          margin-top: 40px;
        }

        .info-card {
        //   border: 1px solid #e5e5e5;
          border-radius: 12px;
          padding: 24px;
          background-color: #f0fff0;
        }

        .info-card h3 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 12px;
          text-align: left;
          color: #0C4D45;
        }

        .info-card p {
          font-size: 15px;
          line-height: 1.6;
          color: #141414;
          text-align: left;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .content-title {
            font-size: 26px;
          }

          .card-row {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

        <div className="content-container">
          <h2 className="content-title">
            Helping Businesses Grow Smarter with WhatsApp Automation
          </h2>

          <p className="content-para">
            Today’s customers expect fast responses and relevant conversations.
            Delayed replies and manual messaging can slow growth. That’s where
            Anlook makes the difference.
          </p>

          <p className="content-para">
            We help businesses scale smarter by automating WhatsApp
            conversations without losing the personal touch. Anlook enables
            brands to stay available 24/7, guide customers through intelligent
            chat flows, and handle high volumes of conversations with ease.
          </p>

          <p className="content-para">
            By using Anlook, businesses can respond faster, improve customer
            satisfaction and boost conversions while reducing manual effort and
            operational costs. It’s smarter communication built for modern
            customer expectations.
          </p>

          {/* Cards */}
          <div className="card-row">
            <div className="info-card">
              <h3>Our Vision</h3>
              <p>
                To become a trusted global platform that transforms WhatsApp
                into the most effective channel for business communication,
                customer engagement, and long-term growth.
              </p>
            </div>

            <div className="info-card">
              <h3>Our Mission</h3>
              <p>
                Our mission is to empower businesses of all sizes with simple,
                secure, and scalable WhatsApp automation solutions. We aim to
                help brands connect with customers more efficiently, engage them
                meaningfully, and convert conversations into lasting
                relationships through faster, smarter, and more human
                communication.
              </p>
            </div>
          </div>
        </div>
      </>

      {/* third section */}
      <>
        <style>{`
        .section-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 60px 20px;
        }

        .section-title {
          font-size: 32px;
          font-weight: 700;
          text-align: center;
          margin-bottom: 16px;
          color: #0C4D45;
        }

        .section-para {
          font-size: 16px;
          line-height: 1.7;
          text-align: center;
          max-width: 600px;
          margin: 0 auto 40px;
          color: #444;
        }

        .section-para1 {
          font-size: 18px;
          line-height: 1.4;
          text-align: left;
          max-width: 900px;
          margin: 0 auto;
          color: #444;
          margin-top: 15px;
        }

        .info-card1 {
          border: 1px solid #e5e5e5;
          border-radius: 12px;
          padding: 40px;
          background: #0C4D45;
          max-width: 900px;
          margin: 0 auto;
        }

        .card-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
        }

        .card-side h3 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 12px;
          text-align: left;
          color: #ffffff;
        }

        .card-side p {
          font-size: 15px;
          line-height: 1.6;
          color: #ffffff;
          text-align: left;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .section-title {
            font-size: 26px;
          }

          .card-content {
            grid-template-columns: 1fr;
            gap: 24px;
          }

          .info-card {
            padding: 24px;
          }
        }
      `}</style>

        <div className="section-container">
          <h2 className="section-title">What Anlook Does</h2>

          {/* Center Paragraph */}
          <p className="section-para">
            Anlook is an all in one WhatsApp communication and automation
            platform built to help businesses grow faster and communicate better
          </p>

          {/* Card */}
          <div className="info-card1">
            <div className="card-content">
              {/* Left Side */}
              <div className="card-side">
                <h2 className="text-start mb-3 fw-bold text-white fs-5">
                  WhatsApp Campaign Management
                </h2>
                <p>
                  Launch bulk messaging campaigns, promotional broadcasts, and
                  announcement messages with high delivery rates and measurable
                  engagement. Anlook helps you reach customers at scale without
                  sacrificing reliability.
                </p>

                <h2 className="text-start mb-3 fw-bold text-white fs-5">
                  Personalized Customer Messaging
                </h2>
                <p>
                  Send relevant, personalized messages using customer data and
                  behavior insights. Deliver conversations that feel one-to-one,
                  build trust, and drive higher response and conversion rates
                </p>
              </div>

              {/* Right Side */}
              <div className="card-side">
                <h2 className="text-start mb-3 fw-bold text-white fs-5">
                  Automated Replies & Smart Chat Flows
                </h2>
                <p>
                  Automate common customer interactions with intelligent replies
                  and guided chat journeys. Stay available 24/7, reduce response
                  time, and handle customer queries efficiently without manual
                  effort.
                </p>

                <h2 className="text-start mb-3 fw-bold text-white fs-5">
                  Analytics & Performance Insights
                </h2>
                <p>
                  Monitor message delivery, customer engagement, and campaign
                  performance in real time. Use actionable insights to optimize
                  your WhatsApp strategy and improve results continuously.
                </p>
              </div>
            </div>
          </div>
        </div>
      </>

      {/* forth section */}
      <FaqSection />
      <CtaSection />
      <Footer />

      {/* {showFreeTrial && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      zIndex: 9999,
      overflowY: "auto",
    }}
  >
    <button
      onClick={() => setShowFreeTrial(false)}
      style={{
        position: "fixed",
        top: "15px",
        right: "20px",
        background: "#ffffff",
        border: "none",
        borderRadius: "50%",
        width: "36px",
        height: "36px",
        fontSize: "18px",
        cursor: "pointer",
        zIndex: 10000,
      }}
    >
      ✕
    </button>

    <FreeTrial />
  </div>
)} */}

    </>
  );
};

export default AboutUs;
